export default __webpack_public_path__ + "lib/example.450cf14c6c6d4f14fede9bd9f9abf560.jpg";